<template>
  <div v-masonry transition-duration="0.3s" item-selector=".cate-item" >
    <iframe ref="ifram" width="100%"></iframe>
    <cate class="cate-item" v-for="cate in data" :key="cate.id" :data="cate" v-masonry-tile @preview="preview" />
    <!-- <el-image
      ref="preview"
      style="visibility: hidden;"
      :src="curUrl"
      :preview-src-list="[curUrl]">
    </el-image> -->
    <el-dialog
      title="图片预览"
      :visible.sync="previewVisible"
      top="20px"
      width="30%"
      :before-close="() => previewVisible = false">
      <div class="img-wrapper">
        <img :src="curUrl" alt="图片">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cate from "./cate-item.vue";
export default {
  components: {
    cate
  },
  props: {
    data: {
      type: Array,
      require: true
    },
  },
  data () {
    return {
      curUrl: '',
      previewVisible: false
    }
  },
  watch: {
    data: {
      handler: function() {
        this.$nextTick(this.$redrawVueMasonry)
      },
      immediate: true
    }
  },
  mounted() {
    const ifWindow = this.$refs.ifram.contentWindow
    ifWindow.addEventListener('resize', this.$redrawVueMasonry)
    this.$once('hook:beforeDestroy', ()=>{
      ifWindow.removeEventListener('resize', this.$redrawVueMasonry)
    })
  },
  methods: {
    preview (src) {
      this.curUrl = src
      this.previewVisible = true
    }
  },
};
</script>

<style lang="scss" scoped>
  .img-wrapper {
    height: 600px;
    overflow: auto;
    text-align: center;
  }
</style>

